import React, { useState } from 'react';

function NoteListAddPanel({ onAdd, onCancel }) {
  const [name, setName] = useState('');
  const [error, setError] = useState(null);

  const handleOk = () => {
    if (!name.trim()) {
      setError('Nazwa nie może być pusta');
      return;
    }
    setError(null);
    onAdd(name.trim());
  };

  return (
    <div style={{
      background: '#fff',
      borderRadius: 16,
      padding: 32,
      minWidth: 320,
      boxShadow: '0 2px 16px rgba(0,0,0,0.15)',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      zIndex: 11000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <h3 style={{ marginBottom: 24 }}>Nowa lista notatek</h3>
      <input
        type="text"
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder="Nazwa listy"
        style={{
          fontSize: '1.1rem',
          padding: '10px',
          borderRadius: 8,
          border: '1px solid #bbb',
          width: 220,
          marginBottom: 16
        }}
        autoFocus
      />
      {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}
      <div style={{ display: 'flex', gap: 16 }}>
        <button
          onClick={handleOk}
          style={{
            padding: '10px 24px',
            fontSize: '1.1rem',
            fontWeight: 600,
            borderRadius: 8,
            border: '1px solid #6cf',
            background: '#eaf6ff',
            color: '#227',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
        >OK</button>
        <button
          onClick={onCancel}
          style={{
            padding: '10px 24px',
            fontSize: '1.1rem',
            fontWeight: 600,
            borderRadius: 8,
            border: '1px solid #f66',
            background: '#fff0f0',
            color: '#a22',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
        >Anuluj</button>
      </div>
    </div>
  );
}

export default NoteListAddPanel;
